export var CHEGG = {
  UA: {
    COUNTRY_DATA: 'chegg.ua.countryData'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/constants/StorageConstants.js
// module id = 1382
// module chunks = 11